import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

function SignUp(props) {
  const [error, setError] = useState([]);
  const [isCreated, setIsCreated] = useState(false);
  const [sucessMessage, setsucessMessage] = useState("");
  const navigate = useNavigate();

  const [state, setState] = React.useState({
    name: "",
    email: "",
    password: "",
    repeat_password: "",
  });

  const handleChange = (event) => {
    const value = event.target.value;
    setState({
      ...state,
      [event.target.name]: value,
    });
  };

  // handle button click of SignUp form
  const handleSignup = (event) => {
    event.preventDefault();

    setError([]);

    var formData = new FormData();
    formData.append("email", state.email);
    formData.append("password", state.password);
    formData.append("repeat_password", state.repeat_password);
    formData.append("name", state.name);

    // console.log(formData);

    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}v1/user/signup`,
      headers: {
        Accept: "application/json",
        "content-type": "application/json",
      },
      data: formData,
    })
      .then((response) => {
        if (response.status === 200) {
          setIsCreated(true);
          setsucessMessage(response.data.message);
          // console.log(response.data.message);
          // console.log(sucessMessage);
          Array.from(document.querySelectorAll("input")).forEach(
            (input) => (input.value = "")
          );
          navigate("/login");
        }
      })
      .catch((error) => {
        // console.log(error.response.data.errors.email[0]);
        if (error.response.status === 422) {
          setError(error.response.data.errors);
        } else if (error.response.status === 500) {
          // setError(error.response.data.message);
        } else {
          // setError(error.response.data.message);
        }
        // if (error.response.status === 200) setError(error.data.message);
        // else setError("Something went wrong. Please try again later.");
        // if (error.response.status === 422) {
        //   console.log(error.response);
        //   setError(error.response.data.message);
        // } else if (error.response.status === 401) {
        //   setError(error.response.data.message);
        // } else if (error.response.status === 500) {
        //   setError(error.response.data.message);
        // } else {
        //   setError("Something went wrong. Please try again later.");
        // }
      });
  };

  return (
    <>
      {/* <form> */}
      <div
        className="d-flex flex-column flex-root"
        style={{ marginTop: "20px" }}
      >
        <div className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed">
          <div className="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
            <img
              src="/images/logo-dark.png"
              alt="logo"
              className="w-550px ms-n18 m-logo"
            />
            <div className="w-lg-400px bg-body rounded p-10 p-lg-10 mt-10 border-black">
              <p style={{ color: "green", fontSize: "20px" }}>
                {sucessMessage}
              </p>

              <form
                className="form w-100"
                noValidate="novalidate"
                method="POST"
                onSubmit={handleSignup}
              >
                <div className="text-center mb-5">
                  <h1 className="text-dark mb-3 text-start">Create Account</h1>
                </div>
                {/* <p style={{ color: "red" }}>{error ? error : ""}</p> */}

                <div className="fv-row mb-10">
                  <label className="form-label fs-6 fw-bolder text-dark">
                    Name
                  </label>
                  <input
                    className="form-control form-control-lg form-control-solid"
                    type="text"
                    name="name"
                    id="name"
                    placeholder="Name"
                    onChange={handleChange}
                    required
                  />
                  <p style={{ color: "red" }}>
                    {error.name !== undefined && error.name[0]
                      ? error.name[0]
                      : ""}
                  </p>
                </div>

                <div className="fv-row mb-10">
                  <label className="form-label fs-6 fw-bolder text-dark">
                    Email
                  </label>
                  <input
                    className="form-control form-control-lg form-control-solid"
                    type="text"
                    name="email"
                    id="email"
                    placeholder="name@example.com"
                    onChange={handleChange}
                    required
                  />
                  <p style={{ color: "red" }}>
                    {error.email !== undefined && error.email[0]
                      ? error.email[0]
                      : ""}
                  </p>
                </div>

                <div className="fv-row mb-10">
                  <div className="d-flex flex-stack mb-2">
                    <label className="form-label fw-bolder text-dark fs-6 mb-0">
                      Password
                    </label>
                    {/*end::Link*/}
                  </div>
                  {/*end::Wrapper*/}
                  {/*begin::Input*/}
                  <input
                    className="form-control form-control-lg form-control-solid"
                    type="password"
                    name="password"
                    id="password"
                    onChange={handleChange}
                    placeholder="At least 8 characters"
                    required
                  />
                  <p style={{ color: "red" }}>
                    {error.password !== undefined && error.password[0]
                      ? error.password[0]
                      : ""}
                  </p>
                  {/*end::Input*/}
                </div>

                <div className="fv-row mb-10">
                  <div className="d-flex flex-stack mb-2">
                    <label className="form-label fw-bolder text-dark fs-6 mb-0">
                      Re-enter Password
                    </label>
                    {/*end::Link*/}
                  </div>
                  {/*end::Wrapper*/}
                  {/*begin::Input*/}
                  <input
                    className="form-control form-control-lg form-control-solid"
                    type="password"
                    name="repeat_password"
                    id="repeat_password"
                    onChange={handleChange}
                    placeholder="Repeat Password"
                    required
                  />
                  {/*end::Input*/}
                </div>
                {/*end::Input group*/}
                {/*begin::Actions*/}
                <div className="text-center">
                  {/*begin::Submit button*/}
                  <button type="submit" className="btn btn-lg btn-dark w-100">
                    <span className="indicator-label">Create your Account</span>
                  </button>
                  {/*end::Separator*/}
                </div>

                <div className="text-center">
                  <div className="fw-bolder text-start mt-5 fs-5 text-dark-400">
                    Already have an account?&nbsp;
                    <Link to="/login" className="link-primary">
                      Sign In
                    </Link>
                  </div>
                </div>
                {/*end::Actions*/}
              </form>
              {/*end::Form*/}
            </div>
            {/*end::Wrapper*/}
          </div>
          {/*end::Content*/}
          {/*begin::Footer*/}
          {/* <div className="d-flex flex-center flex-column-auto p-10">
            <div className="d-flex align-items-center fw-bold fs-6">
              <a href="/#" className="text-muted text-hover-primary px-2">
                About
              </a>
              <a href="/#" className="text-muted text-hover-primary px-2">
                Contact
              </a>
              <a href="/#" className="text-muted text-hover-primary px-2">
                Contact Us
              </a>
            </div>
          </div> */}
          {/*end::Footer*/}
        </div>
        {/*end::Authentication - Sign-in*/}
      </div>
    </>
  );
}

export default SignUp;
